import React, { Component } from 'react';
import { observer } from 'mobx-react';
import getErrorBoundary from 'core/util/getErrorBoundary';
import { createToolResultComponent } from './ToolResultFactory';
import SubAgentTranscriptPanel from './components/SubAgentTranscriptPanel';
import { KaizenToolResultPanelWrapper } from './KaizenChatSession.styles';

// make an error boundary for the tool result panel so if one of the tools fails to render, it doesn't break the whole page
const ErrorBoundaryCmp = getErrorBoundary('KaizenToolResultPanel');

/**
 * Renders a <Card> that when clicked, opens the side Modal with the
 * query the tool returned.
 */

@observer
class KaizenToolResultPanel extends Component {
  scrollRef = React.createRef();

  componentDidUpdate(prevProps) {
    const { tools } = this.props;
    if (tools && prevProps.tools && tools.length !== prevProps.tools.length) {
      const node = this.scrollRef.current;
      if (node) {
        node.scrollTo({ top: node.scrollHeight, behavior: 'smooth' });
      }
    }
  }

  render() {
    const { tools, onCloseToolResult, onDataViewCreate, onQueryError, onSelectToolResult, sessionModel } = this.props;

    if (!tools || tools.length === 0) {
      return null;
    }

    const chartHeight = 500;

    return (
      <ErrorBoundaryCmp>
        <KaizenToolResultPanelWrapper bg="decks.background" ref={this.scrollRef}>
          {tools.map((tool) => {
            if (tool.kind === 'subagent-transcript') {
              return (
                <SubAgentTranscriptPanel
                  key={tool.id}
                  item={tool}
                  sessionModel={sessionModel}
                  onSelectToolResult={onSelectToolResult}
                  onCloseToolResult={onCloseToolResult}
                />
              );
            }

            return createToolResultComponent(tool, {
              onCloseToolResult,
              onDataViewCreate,
              onQueryError,
              chartHeight
            });
          })}
        </KaizenToolResultPanelWrapper>
      </ErrorBoundaryCmp>
    );
  }
}

export default KaizenToolResultPanel;
